import script from "./PeBeautie.vue?vue&type=script&setup=true&lang=js"
export * from "./PeBeautie.vue?vue&type=script&setup=true&lang=js"

import "./PeBeautie.vue?vue&type=style&index=0&id=2a823d46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a823d46"]])

export default __exports__